// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1g7iQ","inner":"Footer_inner__zK2Ur","nextIcon":"Footer_nextIcon__6wGFM","innerLeft":"Footer_innerLeft__1SJhN"};